import {Type} from "ol/geom/Geometry";

export function normalStyles() {
    const styles: Partial<Record<Type, any>> = {};

    const white = '#FFFFFFAA';
    const blue = '#0099FF';

    styles['Polygon'] = {
        fill: {
            color: white
        },
        stroke: {
            color: blue,
            width: 1.5
        }
    };

    styles['Point'] = {
        image: {
            kind: 'Circle',
            radius: 6,
            fill: { color: white },
            stroke: { color: blue, width: 1.5 }
        }
    };

    styles['LineString'] = {
        stroke: {
            color: blue,
            width: 2
        }
    };

    return styles;
}